import { render, staticRenderFns } from "./ColumnContentTabBar.vue?vue&type=template&id=73b8dad9&scoped=true"
import script from "./ColumnContentTabBar.vue?vue&type=script&lang=js"
export * from "./ColumnContentTabBar.vue?vue&type=script&lang=js"
import style0 from "./ColumnContentTabBar.vue?vue&type=style&index=0&id=73b8dad9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b8dad9",
  null
  
)

export default component.exports